module.exports = __webpack_public_path__ + "img/footer__application4.c48e160.webp";